import React, { ChangeEventHandler } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { CSSProperties } from "styled-components";

interface Props {
	options: any;
	name: string;
	placeholder?: string;
	value: any;
	onChange: ChangeEventHandler<HTMLSelectElement>;
	selectStyle?: CSSProperties;
	disabled?: boolean;
	isInvalid?: boolean;
}

const BftSelect: React.FC<Props> = (props) => {
	const { options, name, placeholder, value, onChange, selectStyle, disabled, isInvalid } = props;

	return (
		<div className="bft-select container">
			<FloatingLabel controlId={name} label={placeholder} className=" mb-3">
				<Form.Select
					name={name}
					aria-label={name}
					onChange={onChange}
					value={value}
					style={selectStyle}
					disabled={disabled}
					isInvalid={isInvalid}
					autoComplete="new-password"
				>
					{options?.map((option: any, index: number) => (
						<option key={name + index} value={option.key}>
							{option.value}
						</option>
					))}
				</Form.Select>
			</FloatingLabel>
		</div>
	);
};

export default BftSelect;
